
<div class="ws-slider">
  <div class="row items-center">
    <div
      v-if="cfg.label"
      class="col-3 text-left text-ws-ui-primary"
    >
      <small><strong>{{ cfg.label }}</strong></small>
    </div>
    <div class="col col-grow">
      <q-slider
        snap
        :value="value"
        v-bind="$attrs"
        :min="cfg.min"
        :max="cfg.max"
        :step="cfg.step"
        :color="$attrs.disable ? 'grey' : cfg.color"
        @input="emitValue"
        v-on="$listeners"
      />
      <div
        v-if="cfg.minLabel && cfg.maxLabel"
        class="row justify-between items-center"
      >
        <small>{{ cfg.minLabel }}</small>
        <small>{{ cfg.maxLabel }}</small>
      </div>
    </div>
    <div
      v-if="cfg.price !== undefined"
      class="col-auto"
    >
      <small class="addon-price text-right text-ws-ui-primary">
        {{
          $n(price, {
            style: 'currency',
            currency,
            currencyDisplay: 'symbol',
          })
        }}
      </small>
    </div>
  </div>
</div>
